export default function SessionDetailsTable({ slotData, userFlow, formatDate, formatTime, getPlatformName }) {
  return (
    <div className="bg-secondary border border-secondary-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-secondary border-b border-secondary-border">
            <tr>
              <th className="text-left py-3 px-4 font-semibold text-foreground">Date</th>
              <th className="text-left py-3 px-4 font-semibold text-foreground">Time</th>
              <th className="text-left py-3 px-4 font-semibold text-foreground">
                {userFlow === 'remote' ? 'Platform' : 'Location'}
              </th>
              <th className="text-left py-3 px-4 font-semibold text-foreground">Duration</th>
              {userFlow === 'remote' && (
                <th className="text-left py-3 px-4 font-semibold text-foreground">Interviewer</th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-secondary-border">
            <tr className="hover:bg-secondary/50">
              <td className="py-3 px-4 text-sm text-foreground">
                {formatDate(slotData.slot_date)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {formatTime(slotData.slot_time, slotData.slot_date)} -{" "}
                {formatTime(slotData.end_time, slotData.slot_date)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {userFlow === 'remote' 
                  ? getPlatformName(slotData.preferred_platform)
                  : slotData.location === "studio" ? "Our Studio" : slotData.location || "Not specified"
                }
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {slotData.duration ? `${Math.floor(slotData.duration / 60)} hours` : 'Not specified'}
              </td>
              {userFlow === 'remote' && (
                <td className="py-3 px-4 text-sm text-foreground">
                  {slotData.interviewer?.name || 'TBD'}
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
} 